angular.module('aq.filters.formatters')
.filter("text", function() {
    return function(input, format) {
        return textural(input).format(format);
    }
 });